module.exports = require("@git-stack/graphql-schema");